export default __webpack_public_path__ + "static/scientist6-881f5db7097762801d9cca89f97056f0.png";